module.exports = __webpack_public_path__ + "img/chart-bar.d9f605fa.svg";